var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"font-weight-bolder mb-0 text-left",class:_vm.statusColor},[_vm._v(" "+_vm._s(_vm.statusText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }